import { render } from "./SalaryMedal.vue?vue&type=template&id=57b1c12c&scoped=true"
import script from "./SalaryMedal.vue?vue&type=script&lang=js"
export * from "./SalaryMedal.vue?vue&type=script&lang=js"

import "./SalaryMedal.vue?vue&type=style&index=0&id=57b1c12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b1c12c"]])

export default __exports__